<template>
  <router-view v-if="isRouterAlive" ></router-view>
</template>
<script>
export default {
  name: 'InviteWxTeam',
  provide() {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/invite-team/index.vue